import styled from "styled-components";


const ProgressBarWrapper = styled.div`
  width: 100%;
  height: 20px;
  border-radius: 22px;
  background: #00000075;
  position: relative;
  overflow: hidden;
  border: 1px solid #FFFFFF;
  padding: 2px;
  backdrop-filter: blur(30px);
`;

const ProgressBarFill = styled.div`
  height: 100%;
  width: ${({ progress }) => progress}%;
  background: linear-gradient(97.79deg, #59B15F 1.69%, #56DED0 39.89%, #6747AC 92.65%);
  border: 1px solid #FFFFFF;
  box-shadow: 0px 4px 4px 0px #00000040 inset;
  border-radius: 22px;
  transition: width 0.3s ease-in-out;
`;


const ProgressBar = ({ progress ,wrapperStyle = {},barStyle={}}) => {
  return (
    <ProgressBarWrapper style={wrapperStyle}>
      <ProgressBarFill style={barStyle} progress={progress} />
    </ProgressBarWrapper>
  );
};

export default ProgressBar;
